import script from "./ImageTextCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageTextCard.vue?vue&type=script&setup=true&lang=ts"

import "./ImageTextCard.vue?vue&type=style&index=0&id=4ea35056&lang=scss"

const __exports__ = script;

export default __exports__